import { Npi } from '../../entities/npi';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class UserContext {
  private npis: Npi[] = [];

  public getNpis (): Npi[] {
    return [ ...this.npis ];
  }

  public addNpi (npi: Npi): this {
    this.npis.push(npi);

    return this;
  }

  public hasNpi (): boolean {
    return this.npis.length > 0;
  }
}
